import React from 'react';

const NebulaRewardTransactionFormModal = React.lazy(() => import('../components/FormModal'));
const nebulaRewardTransactionModalRegistry = {
    personalize_nebulaRewardTransactionId: NebulaRewardTransactionFormModal
};
export default nebulaRewardTransactionModalRegistry;
